import request from '@/utils/request'

let ServiceApi = {

     /*服务商列表*/
  list(data) {
    return request._post('/shop/plus.service.service.Index/index', data);
},
/*添加服务商*/
add(data) {
    return request._post('/shop/plus.service.service.Index/add', data);
},
/*修改服务商*/
edit(data) {
    return request._post('/shop/plus.service.service.Index/edit', data);
},
/*删除服务商*/
del(data) {
    return request._post('/shop/plus.service.service.Index/del', data);
},
/*服务商详情*/
detail(data) {
  return request._post('/shop/plus.service.service.Index/detail', data);
},
//获取
getDetail(data) {
  return request._post('/shop/plus.service.service.Index/getDetail', data);
},
//获取设备收入
log(data){
  return request._post('/shop/plus.service.service.Index/log', data);
},
//获取套餐
package(data){
  return request._post('/shop/plus.service.service.Index/package', data);
},
//获取设备所属
belong(data){
  return request._post('/shop/plus.service.service.Index/belong', data);
},

saveSetting(data, errorback) {
  return request._post('/shop/plus.filiale.Setting/getSetting', data, errorback);
},
getSetting(data, errorback) {
  return request._get('/shop/plus.filiale.Setting/getSetting', data, errorback);
},


setStatus(data){
  return request._post('/shop/plus.service.service.Index/setStatus', data);
},
getFileUser(data){
  return request._post('/shop/plus.service.service.Index/getFileUser', data);

},
getFileUserById(data){
  return request._post('/shop/plus.service.service.Index/getFileUserById', data);

},

//获取需要选择的服务角色
getServiceRole(data){
  return request._post('/shop/plus.service.service.Index/getServiceRole', data);
},
//获取可绑定的服务商
getService(data){
  return request._post('/shop/plus.service.service.Index/getService', data);
},


//服务角色管理
    listRole(data) {
      return request._post('/shop/plus.service.role.Index/list', data);
  },
  /*添加服务角色*/
  addRole(data) {
      return request._post('/shop/plus.service.role.Index/add', data);
  },
  /*修改服务角色*/
  editRole(data) {
      return request._post('/shop/plus.service.role.Index/edit', data);
  },
  /*删除服务角色*/
  delRole(data) {
      return request._post('/shop/plus.service.role.Index/del', data);
  },
  /*服务角色详情*/
  detailRole(data) {
    return request._post('/shop/plus.service.role.Index/detail', data);
  },
   /*服务角色详情*/
   setStatusRole(data) {
    return request._post('/shop/plus.service.role.Index/setStatusRole', data);
  },
}
export default ServiceApi;



// WEBPACK FOOTER //
// ./src/api/service.js